<template>
  <div class="edit-information">
    <HeaderBack :page-name="valueName" @back="$emit('back')" />

    <Form @submit="$emit('save', newValue)">
      <Field
        v-if="!isTextArea"
        class="input"
        :name="valueName"
        v-model="newValue"
        type="text"
        :placeholder="valueName"
        as="input"
        :rules="validatePresence"
      />

      <Field
        v-else
        class="input textarea"
        :name="valueName"
        v-model="newValue"
        :placeholder="valueName"
        as="textarea"
        :rules="validatePresence"
      />

      <button>保存</button>
    </form>
  </div>
</template>

<script>
import { Form, Field } from 'vee-validate';
import HeaderBack from '@/components/helpers/HeaderBack.vue'

export default {
  name: 'EditInformation',

  components: {
    Form,
    Field,
    HeaderBack
  },

  props: {
    valueName: {
      type: String,
      required: true
    },

    originalValue: {
      type: String,
      required: true
    },

    isTextArea: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      newValue: ''
    }
  },

  mounted() {
    this.newValue = this.originalValue
  },

  methods: {
    validatePresence(value) {
      if (!value) {
        return "";
      }

      return true
    }
  }
}
</script>

<style scoped>
.edit-information .input {
  width: 100%;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 30px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #808080;
}

.edit-information .textarea {
  height: 100px;
}

.edit-information button {
  margin: 0 auto;
  width: 100%;
  max-width: 335px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.12px;
  color: #999;
  background-color: white;
  border: 1px solid #999;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.12);
}
</style>
